import { jsx as _jsx } from "react/jsx-runtime";
import Agriculture from '@hellodarwin/icons/dist/icons/Agriculture';
import Alimentation from '@hellodarwin/icons/dist/icons/Alimentation';
import Construction from '@hellodarwin/icons/dist/icons/Construction';
import Enterprise from '@hellodarwin/icons/dist/icons/Enterprise';
import Fabrication from '@hellodarwin/icons/dist/icons/Fabrication';
import Transport from '@hellodarwin/icons/dist/icons/Transport';
import Wood from '@hellodarwin/icons/dist/icons/Wood';
const iconMap = {
    '11': Agriculture,
    '21': Wood,
    '22': Enterprise,
    '23': Construction,
    '41': Enterprise,
    '31-33': Fabrication,
    '44-45': Alimentation,
    '48-49': Transport,
    '51': Enterprise,
    '52': Enterprise,
    '53': Enterprise,
    '54': Enterprise,
    '55': Enterprise,
    '56': Enterprise,
    '61': Enterprise,
    '62': Enterprise,
    '71': Enterprise,
    '72': Alimentation,
    '81': Enterprise,
    '91': Enterprise,
};
const DefaultIcon = Enterprise;
export const getIndustryIcon = (industry, props) => {
    var _a;
    const Icon = (_a = iconMap[industry]) !== null && _a !== void 0 ? _a : DefaultIcon;
    return _jsx(Icon, Object.assign({}, props));
};
